export const isDevelopment = (): boolean =>
  window.location.hostname === 'localhost' ||
  window.location.hostname?.includes('herokuapp') ||
  window.location.hostname?.includes('127.0.0.1') || // For CI
  window.location.hostname?.includes('ngrok-free.app') // For Ngrok
